import { api } from "@/lib/api";

export async function getLatestAnalysis(projectId) {
  const { data } = await api.get(`/projects/${projectId}/analyses`);
  const list = data?.data || [];
  return list[0] || null; // backend sorts desc on created_at
}

export async function getAnalysisById(analysisId) {
  const { data } = await api.get(`/analyses/${analysisId}`);
  return data?.data || null;
}
